export const womenEnrolledTotalCalculation = (props: any) => {
    const {uoas, fields} = props;
    const genderField = fields.find((field: any) => field.key === 'genere');
    const femaleOption = genderField?.options.find((option: any) => option.key === 'female');

    if (!femaleOption) return 0;

    const totalCount = uoas.filter(
        (uoa: any) =>
            uoa.custom_field_values
                .find((custom_field_value: any) => custom_field_value.field_id === genderField.id)?.stored_value === String(femaleOption.id)
    ).length

    return (totalCount / uoas.length * 100).toFixed(2);
}